import { useState } from 'react'

import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_AD_UNIT_AMAZONS } from './api/query'
import { AdUnitAmazonSliceDTO, Data, Variables } from './api/types'
import { AdUnitAmazonSlice, Props, UseGetAdUnitAmazons } from './types'

export const useGetAdUnitAmazons = ({
  domainAmazonId,
  filters,
  first,
  last,
  sort,
}: Props): UseGetAdUnitAmazons => {
  const ability = useAbility()
  const [adUnitAmazons, setAdUnitAmazons] = useState<AdUnitAmazonSlice[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async ({ adUnitAmazons: { nodes, totalCount } }: Data) => {
      if (nodes) {
        setAdUnitAmazons(
          nodes.map((node: AdUnitAmazonSliceDTO): AdUnitAmazonSlice => fromDTO(node)),
        )
        setCount(totalCount)
      }
    },
    options: {
      enabled: domainAmazonId !== undefined,
    },
    query: GET_AD_UNIT_AMAZONS(ability),
    variables: {
      domainAmazonId: domainAmazonId!,
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
    },
  })

  return {
    adUnitAmazons,
    count,
    loading: isLoading,
  }
}
